 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		51: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"component---src-pages-404-mdx","3":"component---src-pages-box-mdx","4":"component---src-pages-button-mdx","5":"component---src-pages-card-mdx","6":"component---src-pages-demo-mdx","7":"component---src-pages-extending-mdx","8":"component---src-pages-flex-mdx","9":"component---src-pages-forms-checkbox-mdx","10":"component---src-pages-forms-index-mdx","11":"component---src-pages-forms-input-mdx","12":"component---src-pages-forms-label-mdx","13":"component---src-pages-forms-radio-mdx","14":"component---src-pages-forms-select-mdx","15":"component---src-pages-forms-slider-mdx","16":"component---src-pages-forms-switch-mdx","17":"component---src-pages-forms-textarea-mdx","18":"component---src-pages-getting-started-mdx","19":"component---src-pages-guides-css-grid-mdx","20":"component---src-pages-guides-index-mdx","21":"component---src-pages-guides-mdx-mdx","22":"component---src-pages-guides-server-side-rendering-mdx","23":"component---src-pages-guides-styled-components-mdx","24":"component---src-pages-guides-theme-ui-mdx","25":"component---src-pages-guides-using-rebass-without-context-mdx","26":"component---src-pages-heading-mdx","27":"component---src-pages-image-mdx","28":"component---src-pages-index-mdx","29":"component---src-pages-layout-index-mdx","30":"component---src-pages-link-mdx","31":"component---src-pages-migrating-mdx","32":"component---src-pages-props-mdx","33":"component---src-pages-recipes-avatar-mdx","34":"component---src-pages-recipes-background-image-card-mdx","35":"component---src-pages-recipes-badge-mdx","36":"component---src-pages-recipes-container-mdx","37":"component---src-pages-recipes-flexbox-align-mdx","38":"component---src-pages-recipes-flexbox-grid-mdx","39":"component---src-pages-recipes-flexbox-wrap-mdx","40":"component---src-pages-recipes-image-card-mdx","41":"component---src-pages-recipes-index-mdx","42":"component---src-pages-recipes-nav-bar-mdx","43":"component---src-pages-recipes-nav-link-mdx","44":"component---src-pages-recipes-video-embed-mdx","45":"component---src-pages-reflexbox-mdx","46":"component---src-pages-space-mdx","47":"component---src-pages-text-mdx","48":"component---src-pages-theming-mdx","49":"component---src-pages-variants-mdx"}[chunkId]||chunkId) + "-" + {"2":"4dcb217fa5bbc2ee1193","3":"57b7e069753393344262","4":"14c66fc92f6d7a7c83ee","5":"6bf680eb44fbfb70adae","6":"9c87adffd7d13c8e62ab","7":"16c308989b3fead85b1c","8":"fd8804581a3edf9266bb","9":"56e4f00ae9e0023bf3b2","10":"71914254c3d422bb4fdc","11":"1db212c6a217ae0eece5","12":"f082eb4297c443c3d2bc","13":"634903adbd137de62e60","14":"919ee15f1be71807d043","15":"839508e033f546289cd5","16":"8386c66a116d7ed31361","17":"3a000b0b2168f2fcab17","18":"853b2f9bb4cdd0770397","19":"ef0f93a6e65dc2c6c359","20":"bcd0a5d4c440ab424ffe","21":"97ad654ae2dc3faa28d1","22":"548ebdf8d9b5a1649a36","23":"b78c54004175d9f20b6d","24":"8208b952c7729c77db33","25":"0fa66a3c6cba7cfbf681","26":"4ad7c46888f54224c748","27":"1476e7aebf7239efc7aa","28":"6093f270c9066b941450","29":"92039538163db68cfa4d","30":"28fb3ca2a66ebd5acd73","31":"9b2b9816a458f9446949","32":"0ae37df04bc20e7b86bb","33":"ccc1820e9e2f8d42282a","34":"044a2d4da7ae39c213cc","35":"d00c1a8394c3f16f1900","36":"64b795fcdb384e503f1d","37":"5c8f938235f419bbec78","38":"853388bf0bf93e28ddee","39":"767605a7c41c600c93f1","40":"5757ec77a92bc2c95dc2","41":"46d9fa4ab0be4f83a499","42":"be5354590ff6ddcf004f","43":"511ed85de229630bba7b","44":"1cfdd3ce017cf058fc0b","45":"c30fb47d2ea4a25ada9f","46":"1df445491626212bc1c1","47":"33ad82516e73b04696f1","48":"f57b696b1550450aae2d","49":"bdadfd724e35f4a06002"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
